import { mapInformeData } from './mapData';

export { mapInformeData };

// Aplana las filas tenant_text (keyName/textValue) del documentType del
// informe en el objeto `data`, para que RichText resuelva el override por
// tenant vía data[textKey].
export function withTenantTexts(data, staticData) {
  const texts = {};
  for (const row of staticData || []) {
    if (row?.documentType === 'informe_mantencion' && row?.keyName) {
      texts[row.keyName] = row.textValue;
    }
  }
  return { ...data, ...texts };
}
